export interface Input {
  content: Marko.Body;
}

<div class="leading4 mb1">
  <${input.content}/>
</div>
